import "../landing.scss";

import { useTranslation } from "react-i18next";

export const useLandingCL = () => {
  const { t } = useTranslation();

  return { t };
};
